<template>
  <main>
    <account-list :account-type="consignees" :action-str-select-chained="onSelectChainedActions" :include-user-instructions="true"/>
    <div class="delivery-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('customerCenter.deliveryInstructions.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-collapse v-model="filtersOpen">
            <el-collapse-item :title="$t('account.instructions')" name="instructions-section" id="instructions-section">
              <el-row>
                <!-- Alarm Instructions -->
                <el-col :span="12" class="form-vertical-item">
                    <label class="span-small-list dos-label">{{ $t('account.alarmInstructions') }}</label>
                    <span class="span-small-list no-cuts" v-html="alarmInstructions"></span>
                </el-col>

                <!-- Delivery Instructions -->
                <el-col :span="12" class="form-vertical-item">
                    <label class="span-small-list dos-label">{{ $t('account.deliveryInstructions') }}</label>
                    <span class="span-small-list no-cuts" v-html="deliveryInstructions"></span>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
     </div>
      <contact-info :account-id="accountId" :is-editable="false"/>
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import { ACCOUNT_SEARCH_CONTACT_INFO } from '@/store/actions';
import constants from '@/utils/constants';
import AccountList from '@/components/AccountList';
import ContactInfo from '../customerMasterRecord/components/contactInfo';

export default {
  name: 'CustomerDetails',
  components: {
    AccountList,
    ContactInfo
  },
  data() {
    return {
      filtersOpen: [],
      alarmInstructions: '',
      deliveryInstructions: '',
      consignees: constants.ACCOUNTS.TYPE[2].value,
      onSelectChainedActions: [[ACCOUNT_SEARCH_CONTACT_INFO, { accountId: this.getAccountId() }]],
    };
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    accountId() {
      return this.user.accountId;
    },
    instructions() {
      return this.user.instructions || {};
    }
  },
  methods: {
    getAccountId() {
      return this.user?.accountId || null;
    },
  },
  watch: {
    instructions(newInstructions) {
      this.alarmInstructions = newInstructions?.alarmInstructions || '';
      this.deliveryInstructions = newInstructions?.deliveryInstructions || '';
      if (this.alarmInstructions || this.deliveryInstructions) {
        if (!this.filtersOpen.includes('instructions-section')) {
          this.filtersOpen.push('instructions-section');
        }
      } else {
        this.filtersOpen = this.filtersOpen.filter(section => section !== 'instructions-section');
      }
    }
  }
};
</script>
<style lang="scss" scoped>

  .no-cuts {
    word-break: normal;
    overflow-wrap: break-word;
    hyphens: none;
    text-wrap: auto;
    text-wrap-style: auto;
  }
  .delivery-view-container {
    margin: 15px 40px;
  }
</style>
